import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../config";

const VerifyEmail = () => {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const { token } = useParams(); // 👈 grab token from path
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No token found in the link.");
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await fetch(`${config.API_BASE_URL}/api/verify/email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        const data = await res.json();

        if (res.ok) {
          // success OR already verified
          setStatus("success");
          setMessage(data.msg || "Email verified successfully!");
          if (data.msg === "Email already verified.") {
            toast.info("Email already verified.");
          } else {
            toast.success("Email verified successfully!");
          }
        } else {
          setStatus("error");
          setMessage(data.error || "Verification failed.");
          toast.error(data.error || "Verification failed.");
        }
      } catch (err) {
        setStatus("error");
        setMessage("Something went wrong.");
        toast.error("Something went wrong.");
      }
    };

    verifyEmail();
  }, [token]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md text-center">
        <h1 className="text-2xl font-bold mb-4">Email Verification</h1>

        {status === "loading" && <p>Verifying your email...</p>}

        {status === "success" && (
          <>
            <p className="text-green-600 mb-4">{message}</p>
            <button
              onClick={() => navigate("/login")}
              className="bg-blue-600 text-white px-4 py-2 rounded-md"
            >
              Go to Login
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <p className="text-red-600 mb-4">{message}</p>
            <button
              onClick={() => navigate("/signup")}
              className="bg-gray-600 text-white px-4 py-2 rounded-md"
            >
              Back to Signup
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
